<template>
    <FormField :field="proxy_form.sale_section_form.fields.sale_sections" namespace="sale_sections" :name="'sale_sections'" class="mb-4" :disabled="!state.available_sale_sections_loaded" />
</template>

<script>
import {onBeforeMount, reactive, watch} from "vue"
import { useVehicleStore } from '@sto/vehicle.store'
import { useSaleStore } from '@sto/sale.store'
import { useAssetStore } from '@sto/asset.store'
import { useSystemStore } from '@sto/system.store'
import { useAuctioneerStore } from '@sto/auctioneer.store'
import { useAuthStore } from '@sto/auth.store'
import { isValid, getPayload, resetFieldset } from '@lib/helpers'

export default {
    props: ['asset', 'sale_section_id'],
    setup(props, {emit}) {

        const VEHICLE_STORE = useVehicleStore()
        const SYSTEM_STORE = useSystemStore()
        const AUTH_STORE = useAuthStore()
        const AUCTIONEER_STORE = useAuctioneerStore()
        const SALE_STORE = useSaleStore()
        const ASSET_STORE = useAssetStore()

        const state = reactive({
            available_sale_sections: [],
            available_sale_sections_loading: false,
            available_sale_sections_loaded: false,
            sale_section_update_modal_active: false,
            sale_section_update_loading: false
        })

        const proxy_form = reactive({
            sale_section_form: {
                fields: {
                    sale_sections: {
                        active: true,
                        label: 'Which sale sections?',
                        type: 'select',
                        value: [],
                        default_value: [],
                        stored_value: '',
                        options: [],
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: true
                    }
                }
            }
        })

        /**
         * get the sale section ids for the scope organisation
         * @param {bool} refresh
         */
        const getAuctioneerSaleSections = async (refresh = false) => {
            // we don't want to hit this unneccessarilt — sale codes are not gonna be changing frequently. no need to re-fetch during state mutation
            // likewise, stop if currently mid ffetch
            if ((state.available_sale_sections.length > 0 && !refresh) || state.available_sale_sections_loading === true) return

            try {
                state.available_sale_sections_loading = true
                const params = []
                const sale_sections = await AUCTIONEER_STORE.getSaleSections(props.asset?.auctioneer_id, params)

                if (!sale_sections.length) {
                    proxy_form.sale_section_form.fields.sale_sections.active = false
                    return
                }

                proxy_form.sale_section_form.fields.sale_sections.disabled = false
                proxy_form.sale_section_form.fields.sale_sections.options_raw = sale_sections
                proxy_form.sale_section_form.fields.sale_sections.options = sale_sections.map(({id, name}) => { return {value: id, label: name} })
                proxy_form.sale_section_form.fields.sale_sections.options.unshift({ value: null, label: 'Choose a Sale Section...'})

                proxy_form.sale_section_form.fields.sale_sections.value = props.sale_section_id
                    ? props.sale_section_id
                    : null

            } catch (error) {
                console.error('SALE_STORE.getSaleSections error', error)
            } finally {
                state.available_sale_sections_loading = false
                state.available_sale_sections_loaded = true
            }
        }

        watch (
            () => proxy_form.sale_section_form.fields.sale_sections.value,
            (new_value) => {
                if (new_value != props.sale_section_id) emit('sale_section_updated', new_value)
            }
        )

        onBeforeMount(() => {
            getAuctioneerSaleSections()
        })

        return {
            state,
            proxy_form
        }

    }
}
</script>